import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';

import './antd.less';

import * as serviceWorker from './serviceWorker';
import { BEANIE_API_KEY, BEANIE_CONFIG_ID } from './constants/payment';

import BeanieProvider from './ctx/beanieProvider';
import BreakpointsProvider from './ctx/breakpointProvider';
import { initSentry } from './utils/sentry';

import { store, history } from './redux/store';

import App from './app';
import ErrorBoundary from './components/errorBoundary';
// import ServiceWorkerWrapper from './components/serviceWorkerWrapper';

initSentry();

render(
  <ErrorBoundary>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <BeanieProvider apiKey={BEANIE_API_KEY} configId={BEANIE_CONFIG_ID}>
          <BreakpointsProvider>
            <App />
          </BreakpointsProvider>
        </BeanieProvider>
      </ConnectedRouter>
    </Provider>
    {/* <ServiceWorkerWrapper /> */}
  </ErrorBoundary>,
  document.getElementById('root'),
);

serviceWorker.unregister();
